import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react';
/**
 * Collapsible thinking/reasoning section.
 * Shows animated indicator while active, collapsed by default when complete.
 *
 * Wrapped in React.memo to prevent re-renders when parent state changes
 * don't affect this component's props.
 */
export const ThinkingBlock = React.memo(function ThinkingBlock({ text, active }) {
    const [expanded, setExpanded] = useState(active);
    return (_jsxs("div", { className: "my-2", children: [_jsxs("button", { onClick: () => setExpanded(!expanded), "aria-expanded": expanded, className: "flex items-center space-x-2 text-xs text-gray-500 hover:text-gray-700", children: [active ? (_jsx("span", { className: "animate-pulse", children: "Thinking..." })) : (_jsx("span", { children: "Thought" })), _jsx(ChevronDown, { size: 12, className: `transition-transform ${expanded ? 'rotate-180' : ''}` })] }), expanded && text && (_jsx("div", { className: "mt-1 ml-4 p-2 bg-gray-50 border-l-2 border-gray-300 text-xs text-gray-600 whitespace-pre-wrap break-words overflow-hidden", children: text }))] }));
});
//# sourceMappingURL=ThinkingBlock.js.map